import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

const contactScopeOptions = [
  { value: '', label: 'All movements' },
  { value: 'network', label: 'Network contacts' },
  { value: 'company', label: 'Portfolio company employees' },
];

export const MovementContactScopeFilter = ({ value, setFilters }) => {
  const onSubmit = ({ contactScope }) => {
    const contactScopeValue = contactScope?.value ?? '';
    setFilters({ contactScope: contactScopeValue });
  };

  const selectedValue = contactScopeOptions.find((opt) => opt.value === value) || contactScopeOptions[0];

  return (
    <Formik initialValues={{ contactScope: selectedValue }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="contactScope"
          label="Contact scope"
          placeholder="All movements"
          component={FormSelect}
          options={contactScopeOptions}
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

MovementContactScopeFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

MovementContactScopeFilter.defaultProps = {
  value: '',
};
